import { render } from "./AddMusical.vue?vue&type=template&id=7f63885a&scoped=true&ts=true"
import script from "./AddMusical.vue?vue&type=script&lang=ts"
export * from "./AddMusical.vue?vue&type=script&lang=ts"

import "./AddMusical.vue?vue&type=style&index=0&id=7f63885a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/chronicle/chronicle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f63885a"]])

export default __exports__